import { ActionTypes } from "../constants/action-types";

const initialState = {
    viewedCoachMarks: {
        sortJobsites: false,
        actionsButton: false,
        itemDetails: false,
        jobsiteDetails: false,
        jobsiteClick: false,
        activePunchEditIcon: false,
        activePunchMultiSpotlight: false,
        activePunchActionDetails: false,
        itemStatusHelp: false,
        itemAssignedToHelp: false,
        itemCommentsHelp: false,
        chatHelp: false,
        blueDotHelp: false,
        greenDotHelp: false,
        orangeDotHelp: false,
        redDotHelp: false,
        createPunchItem_mobile: false,
        createPunchItem_desktop: false,
        tradeModalHelp: false,
        showJobsiteDetailsHelp: false,
        tradeContactHelp: false,
        tradeConfirmedHelp: false,
        whatHappensNext: false,
        firstPhotoHelp: false,
        secondItemGuidance: false,
        hasSeenPunchList_mobile: false,
        hasSeenPunchList_desktop: false,
        addPunchHelp_mobile: false,
        addPunchHelp_desktop: false,
        hasSeenProjectList_mobile: false,
        hasSeenProjectList_desktop: false,
        hasClickedJobsiteDetails: false,
        hasClickedTradeContacts: false,
    }
};

export function coachMarkReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_COACH_MARK_VIEWED:
            return {
                ...state,
                viewedCoachMarks: {
                    ...state.viewedCoachMarks,
                    [payload]: true
                }
            };
        case ActionTypes.SET_COACH_MARKS_BULK:
            return {
                ...state,
                viewedCoachMarks: {
                    ...state.viewedCoachMarks,
                    ...payload
                }
            };
        case ActionTypes.RESET_COACH_MARKS:
            return {
                ...state,
                viewedCoachMarks: {
                    ...initialState.viewedCoachMarks
                }
            };
        default:
            return state;
    }
}
